import {FC, useEffect} from 'react'
import {useNavigate, useParams} from "react-router-dom"
import staticPageContent from "../../lib/static-page-content"
import Service from "../Service"
import Date from "../Date"
import NotFound from "../NotFound"
import Window from "../Window";
import Options from "../Options";
import Contact from "../Contact";
import Car from "../Car";
import ThankYou from "../ThankYou";
import Hjulskifte from "../Hjulskifte/Hjulskifte";

interface Props {
    content: Content,
    booking: Booking,
    setBooking: Function
}

const Main: FC<Props> = ({ content, booking, setBooking }) => {
    const navigate = useNavigate()
    let { slug } = useParams();
    let pageContent:ContentPage = staticPageContent(slug, content);
    let mainComponent:any = [];

    useEffect(() => {
        if(booking.order_key && slug !== 'tack-for-din-bokning')
            navigate('/tack-for-din-bokning') // Nyckeln finns i booking, inte i adressen (GA4)

        if(booking.hjulskifte_key && slug !== 'hjulskifte')
            navigate('/hjulskifte')

    }, [])

    if(!pageContent)
        return;

    switch (pageContent.content_type) {
        case 'car':
            mainComponent = <Car pageContent={pageContent} booking={booking} setBooking={setBooking} content={content}/>
            break;
        case 'service':
            mainComponent = <Service pageContent={pageContent} booking={booking} setBooking={setBooking} content={content}/>
            break;
        case 'window':
            mainComponent = <Window insurance={content.insurance} pageContent={pageContent} booking={booking} setBooking={setBooking} content={content}/>
            break;
        case 'date':
            mainComponent = <Date pageContent={pageContent} booking={booking} setBooking={setBooking} content={content}/>
            break;
        case 'options':
            mainComponent = <Options pageContent={pageContent} booking={booking} setBooking={setBooking} content={content}/>
            break;
        case 'contact':
            mainComponent = <Contact pageContent={pageContent} booking={booking} setBooking={setBooking} content={content}/>
            break;
        case 'complete':
            mainComponent = <ThankYou pageContent={pageContent} booking={booking} setBooking={setBooking}/>
            break;
        case 'hjulskifte':
            mainComponent = <Hjulskifte pageContent={pageContent} booking={booking} setBooking={setBooking}/>
            break;
        default:
            mainComponent = <NotFound />
    }

    return (
        <>
            {mainComponent}
        </>
    );
};

export default Main
